export const SCAN_WEBSITE = "SCAN_WEBSITE";
export const SUBMIT_REPORT = "SUBMIT_REPORT";
export const STORE_CONTACT = "STORE_CONTACT";